import WebApiBand from './WebApiBand';

export class CommercialPlanService {
  static async searchAll() {
    const response = await WebApiBand.get('/comercialPlain', {
      page: 1,
      limit: 999
    });
    return response.data.result;
  }

  static async searchPlanByStations(station) {
    let plans = [];

    const response = await WebApiBand.get(`/comercialPlainRegional/${station.UF}`);
    const result = response.data.result;

    const stationPlans = result.find(s => s._id === station._id);

    if (stationPlans) {
      plans = [...stationPlans.planos];
    } else {
      result.forEach(station => {
        station.planos.forEach(plan => {
          const inArray = plans.find(p => p._id === plan._id);
          if (!inArray)
            plans = [...plans, plan];
        });
      })
    }

    return plans;
  }

  static async searchProjectsByStation(station) {
    let projects = [];

    const response = await WebApiBand.get(`/specialProjectsRegional/${station.UF}`);
    const result = response.data.result;

    const stationProjects = result.find(s => s._id === station._id);

    if (stationProjects) {
      projects = [...stationProjects.planos];
    } else {
      result.forEach(station => {
        station.planos.forEach(plan => {
          const inArray = projects.find(p => p._id === plan._id);
          if (!inArray)
            projects = [...projects, plan];
        });
      });
    }

    return projects;
  }

  static async searchProjects() {
    const response = await WebApiBand.get('/specialProjects', {
      page: 1,
      limit: 999
    });
    return response.data.result;
  }

  static async searchStations() {
    const response = await WebApiBand.get('/emissoras');
    return response.data.result.filter(e => e.UF !== 99);
  }
}
